const pad = (value: number) => String(value).padStart(2, "0");

const toApiDateFormat = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const getQuarterDateRange = (referenceDate: Date = new Date()) => {
  const endDate = new Date(referenceDate);
  const startDate = new Date(referenceDate);
  startDate.setMonth(startDate.getMonth() - 3);

  return {
    startDate: toApiDateFormat(startDate),
    endDate: toApiDateFormat(endDate),
  };
};
